{
  "name": "@videojs/core",
  "version": "10.0.0-rc.1",
  "description": "Core components and utilities for Video.js",
  "keywords": [
    "core",
    "player",
    "videojs"
  ],
  "license": "Apache-2.0",
  "repository": {
    "type": "git",
    "url": "https://github.com/videojs/v10",
    "directory": "packages/core"
  },
  "files": [
    "dist"
  ],
  "type": "module",
  "sideEffects": [
    "./dist/*/i18n.js",
    "**/i18n/registry.js"
  ],
  "main": "dist/default/index.js",
  "module": "dist/default/index.js",
  "types": "dist/dev/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/dev/index.d.ts",
      "development": "./dist/dev/index.js",
      "default": "./dist/default/index.js"
    },
    "./dom": {
      "types": "./dist/dev/dom.d.ts",
      "development": "./dist/dev/dom.js",
      "default": "./dist/default/dom.js"
    },
    "./vjsc": {
      "types": "./dist/dev/vjsc.d.ts",
      "development": "./dist/dev/vjsc.js",
      "default": "./dist/default/vjsc.js"
    },
    "./i18n": {
      "types": "./dist/dev/i18n.d.ts",
      "development": "./dist/dev/i18n.js",
      "default": "./dist/default/i18n.js"
    },
    "./i18n/locales/*": {
      "types": "./dist/dev/i18n/locales/*.d.ts",
      "development": "./dist/dev/i18n/locales/*.js",
      "default": "./dist/default/i18n/locales/*.js"
    },
    "./i18n/text/*": {
      "types": "./dist/dev/i18n/text/*.d.ts",
      "development": "./dist/dev/i18n/text/*.js",
      "default": "./dist/default/i18n/text/*.js"
    }
  },
  "publishConfig": {
    "exports": {
      ".": {
        "types": "./dist/dev/index.d.ts",
        "development": "./dist/dev/index.js",
        "default": "./dist/default/index.js"
      },
      "./dom": {
        "types": "./dist/dev/dom.d.ts",
        "development": "./dist/dev/dom.js",
        "default": "./dist/default/dom.js"
      },
      "./i18n": {
        "types": "./dist/dev/i18n.d.ts",
        "development": "./dist/dev/i18n.js",
        "default": "./dist/default/i18n.js"
      },
      "./i18n/locales/*": {
        "types": "./dist/dev/i18n/locales/*.d.ts",
        "development": "./dist/dev/i18n/locales/*.js",
        "default": "./dist/default/i18n/locales/*.js"
      },
      "./i18n/text/*": {
        "types": "./dist/dev/i18n/text/*.d.ts",
        "development": "./dist/dev/i18n/text/*.js",
        "default": "./dist/default/i18n/text/*.js"
      }
    },
    "access": "public"
  },
  "scripts": {
    "generate:locales": "node --import tsx ./scripts/generate-i18n-locales.ts",
    "generate:i18n-types": "node --import tsx ./scripts/generate-i18n-types.ts",
    "build:watch": "vp pack --watch ./src --no-clean",
    "dev": "pnpm run build:watch",
    "test": "vp run @videojs/core#build && pnpm run test:types && vp test run",
    "test:types": "tsgo --project ./src/core/ui/tests/tsconfig.json",
    "test:watch": "vp test",
    "clean": "rimraf --glob dist types '*.tsbuildinfo'"
  },
  "dependencies": {
    "@videojs/media": "workspace:*",
    "@videojs/store": "workspace:*",
    "@videojs/utils": "workspace:*"
  },
  "devDependencies": {
    "jsdom": "^26.1.0",
    "typescript": "^6.0.2",
    "vite-plus": "catalog:",
    "vitest": "catalog:",
    "vjsc": "workspace:*"
  }
}
